var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"spanner"},[_c('div',{staticClass:"loader"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.msg)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }